import { useEffect, useState } from 'react'

export default function useMediaQuery() {
  const [device, setDevice] = useState<'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'mobile' | null>(null)
  const [dimensions, setDimensions] = useState<{
    width: number
    height: number
  } | null>(null)

  useEffect(() => {
    const checkDevice = () => {
      if (window.matchMedia('(max-width: 639px)').matches) {
        setDevice('mobile')
      } else if (window.matchMedia('(min-width: 640px) and (max-width: 767px)').matches) {
        setDevice('sm')
      } else if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        setDevice('md')
      } else if (window.matchMedia('(min-width: 1024px) and (max-width: 1279px)').matches) {
        setDevice('lg')
      } else if (window.matchMedia('(min-width: 1280px) and (max-width: 1535px)').matches) {
        setDevice('xl')
      } else {
        setDevice('2xl')
      }
      setDimensions({ width: window.innerWidth, height: window.innerHeight })
    }

    // Initial detection
    checkDevice()

    // Listener for windows resize
    window.addEventListener('resize', checkDevice)

    // Cleanup listener
    return () => {
      window.removeEventListener('resize', checkDevice)
    }
  }, [])

  return {
    device,
    width: dimensions?.width,
    height: dimensions?.height,
    isMobile: device === 'mobile',
    isSm: device === 'sm',
    isMd: device === 'md',
    isLg: device === 'lg',
    isXl: device === 'xl',
    is2xl: device === '2xl',
  }
}
